import styles from './delete-product-category-dialog.module.scss';
import { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface DeleteProductCategoryDialogProps {
  open: boolean,
  onClose: () => void,
  groupName: string,
  groupId: string
}

export function DeleteProductCategoryDialog(props: DeleteProductCategoryDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const handleDeleteProductGroup = () => {
    makeRequest(`relationProductgroups/${props.groupId}`, 'DELETE')
      .then(result => {
        setSnackbarMessage({ content: t("deleteProductCategtory.groupDeleted"), type: "success" });
        props.onClose();
      }).catch(() => setSnackbarMessage({ content: t("deleteProductCategtory.couldNotDeleteGroup"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth='sm'>
      <DialogTitle className='mb-3'>
        {t("standard.areYouSureYouWantToDelete")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'>
          {t("standard.productCategory")}: {props.groupName}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          onClick={handleDeleteProductGroup}
          className='minButtonWidth'>
          {t("deleteProductCategtory.deleteProductCategory")}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteProductCategoryDialog;